<template>
    <div>
        <div v-if="totalPages > 1" class="pagination">
            <div
                @click="onClickFirstPage"
                class="pagination-item"
                :class="{'inactive': isInFirstPage}"
            >
                <svg-icon icon="chevron-double-left" class="w-4 h-4"></svg-icon>
            </div>

            <div
                @click="onClickPreviousPage"
                class="pagination-item"
                :class="{'inactive': isInFirstPage}"
            >
                <svg-icon icon="chevron-left" class="w-4 h-4"></svg-icon>
            </div>

            <div v-for="page in pages" :key="page.value"
                 @click="onClickPage(page.value)"
                 class="pagination-item"
                 :class="{
                 'inactive': page.disabled,
                 'active': isPageActive(page.value),
             }"
            >
                {{ page.value }}
            </div>

            <div
                @click="onClickNextPage"
                class="pagination-item"
                :class="{'inactive': isInLastPage}"
            >
                <svg-icon icon="chevron-right" class="w-4 h-4"></svg-icon>
            </div>

            <div
                @click="onClickLastPage"
                class="pagination-item"
                :class="{'inactive': isInLastPage}"
            >
                <svg-icon icon="chevron-double-right" class="w-4 h-4"></svg-icon>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 3,
        },
        totalPages: {
            type: Number,
            required: true,
            default: 0
        },
        perPage: {
            type: Number,
            required: true,
            default: 20,
        },
        currentPage: {
            type: Number,
            required: true,
            default: 1,
        },
    },
    data() {
        return {};
    },
    computed: {
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        startPage() {
            if (this.currentPage === 1) {
                return 1;
            }

            if (this.currentPage === this.totalPages) {
                let startPage = this.totalPages - this.maxVisibleButtons;
                if (startPage < 1) {
                    return 1;
                }
            }

            return this.currentPage - 1;
        },
        pages() {
            const range = [];

            for (
                let i = this.startPage;
                i <= Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
                i++
            ) {
                range.push({
                    value: i,
                    disabled: i === this.currentPage
                });
            }

            return range;
        },
    },
    methods: {
        isPageActive(page) {
            return this.currentPage === page;
        },
        onClickFirstPage() {
            if (this.currentPage !== 1) {
                this.$emit('pageChanged', 1);
            }
        },
        onClickPreviousPage() {
            if (this.currentPage - 1 > 0) {
                this.$emit('pageChanged', this.currentPage - 1);
            }
        },
        onClickPage(page) {
            if (page !== this.currentPage) {
                this.$emit('pageChanged', page);
            }
        },
        onClickNextPage() {
            if (this.currentPage + 1 <= this.totalPages) {
                this.$emit('pageChanged', this.currentPage + 1);
            }
        },
        onClickLastPage() {
            if (this.currentPage !== this.totalPages) {
                this.$emit('pageChanged', this.totalPages);
            }
        }
    }
}
</script>